var map = {
	"./en-uk.json": [
		1200,
		113
	],
	"./en.json": [
		1201,
		112
	],
	"./es.json": [
		1202,
		114
	],
	"./fi.json": [
		1203,
		115
	],
	"./widgets/en-uk.json": [
		887,
		9
	],
	"./widgets/en.json": [
		888,
		8
	],
	"./widgets/es.json": [
		889,
		10
	],
	"./widgets/fi.json": [
		890,
		11
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 784;
module.exports = webpackAsyncContext;